import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';
import { FaShieldAlt, FaBug, FaLock, FaUserSecret, FaClipboardCheck, FaBell, FaUserShield, FaNetworkWired } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/s.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
    title: "Security Assessment & Auditing",
    description: "Identify vulnerabilities and assess your security posture. Receive actionable recommendations to strengthen defenses.",
  },
  {
    icon: <FaBug size={80} color="var(--brand-primary)" />,
    title: "Penetration Testing",
    description: "Simulate real-world attacks to uncover weaknesses. Protect your systems before threats become breaches.",
  },
  {
    icon: <FaLock size={80} color="var(--brand-primary)" />,
    title: "Vulnerability Management",
    description: "Continuously monitor and remediate security gaps. Stay ahead of evolving cyber threats and compliance needs.",
  },
  {
    icon: <FaUserSecret size={80} color="var(--brand-primary)" />,
    title: "Incident Response Planning",
    description: "Prepare for and respond to security incidents. Minimize impact and recover quickly from breaches.",
  },
  {
    icon: <FaClipboardCheck size={80} color="var(--brand-primary)" />,
    title: "Compliance & Governance",
    description: "Ensure your business meets industry regulations. Implement best practices for data protection and privacy.",
  },
  {
    icon: <FaBell size={80} color="var(--brand-primary)" />,
    title: "Threat Intelligence & Monitoring",
    description: "Monitor for emerging threats and suspicious activity. Gain real-time insights to proactively defend your assets.",
  },
  {
    icon: <FaUserShield size={80} color="var(--brand-primary)" />,
    title: "Security Training & Awareness",
    description: "Empower your team with security best practices. Reduce risk through ongoing education and awareness programs.",
  },
  {
    icon: <FaNetworkWired size={80} color="var(--brand-primary)" />,
    title: "Security Architecture Design",
    description: "Design and implement robust security architectures. Build a strong foundation for long-term protection.",
  },
];

const SecurityConsultation = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Security Consultation - Syrol Tech</title>
        <meta name="description" content="Expert security consultation services. Get tailored solutions to protect your business and data from cyber threats." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Security Consultation"
        pageName="Security Consultation"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Protect Your Business with Security Experts</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>Safeguard your data and operations with our security consultation services. We deliver tailored strategies to defend against cyber threats and ensure compliance.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', background: '#111', color: '#fff'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Security Consultation Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default SecurityConsultation; 